import Vue from 'vue'
import store from './store'
import daTranslations from "../dist/i18n/da.json"
import enTranslations from "../dist/i18n/en.json"
import deTranslations from "../dist/i18n/de.json"
import Polyglot from 'vue-polyglot';

Vue.use(Polyglot, {
    defaultLanguage: 'da',
    languagesAvailable: ['en', 'da', 'de']
});

Vue.locales({
    "da": daTranslations,
    "en": enTranslations,
    "de": deTranslations
});


// WEBPACK FOOTER //
// ./src/lang.js